import React from 'react';
import { renderProcessedText } from '../../utils/textRenderer';

interface CurrentPlanCardProps {
  content: {
    title?: string;
    header?: string;
    description?: string;
    options?: Array<{
      key: string;
      value: string;
      icon?: string;
    }>;
    actualAmount?: string;
    originalAmount?: string;
    currency?: string;
  } | Array<{
    title?: string;
    header?: string;
    description?: string;
    options?: Array<{
      key: string;
      value: string;
      icon?: string;
    }>;
    actualAmount?: string;
    originalAmount?: string;
    currency?: string;
  }>;
  isCarousel?: boolean;
}

const CurrentPlanCard: React.FC<CurrentPlanCardProps> = ({ content, isCarousel }) => {
  // Debug logging
  console.log('CurrentPlanCard received content:', content);
  console.log('Content type:', typeof content);
  console.log('Content keys:', content ? Object.keys(content) : 'content is null/undefined');

  // Normalize content to always be an array
  const normalizedContent = Array.isArray(content) ? content : [content];

  // Safety check for content
  if (!content) {
    return <div className="current-plan-error">No plan data available</div>;
  }
  console.log(normalizedContent)

  return (
    <div className="current-plan" style={{ height: isCarousel ? '100%' : 'auto' }}>
      {normalizedContent.map((plan, index) => (
          <React.Fragment key={index}>
            <div className="current-plan__card">
              {/* Top header - like "LOYALTY OFFER" */}
              {plan?.header && (
                <div className="current-plan__category">
                  {renderProcessedText(plan.header)}
                </div>
              )}
              
              {/* Main title - like "Stay & Save" */}
              <div className="current-plan__main-title">
                {renderProcessedText(plan?.title || 'Current Plan')}
              </div>
              
              {/* Description */}
              {plan?.description && (
                <div className="current-plan__description">
                  {renderProcessedText(plan.description)}
                </div>
              )}
              
              {/* Features list in key-value format */}
              <div className="current-plan__features">
                {plan?.options && Array.isArray(plan.options) && plan.options.map((option, optionIndex) => (
                  <div key={optionIndex} className="current-plan__feature-item">
                    {option?.icon && (
                      <div className="current-plan__feature-icon">
                        {option.icon === 'tick' && (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20 6L9 17L4 12" stroke="#007bff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        )}
                      </div>
                    )}
                    <div className="current-plan__feature-key">
                      {renderProcessedText(option?.key || 'Feature')}
                    </div>
                    <div className="current-plan__feature-value">
                      {renderProcessedText(option?.value || 'No value')}
                    </div>
                  </div>
                ))}
              </div>
              
              {/* Price section at bottom */}
              {plan?.actualAmount && (
                <div className="current-plan__pricing">
                  {plan?.originalAmount ? (
                    // Show promotional pricing format: "€50/month for 12 months, then €120/month"
                    <span className="current-plan__promotional-price">
                      {plan.actualAmount}/month for 12 months, then {plan.originalAmount}/month
                    </span>
                  ) : (
                    // Show single price
                    <span className="current-plan__current-price">
                      {plan.actualAmount}/m
                    </span>
                  )}
                </div>
              )}
            </div>
            <hr style={{ border: 'none', borderTop: '1px solid #e5e7eb', margin: '16px 0' }} />
          </React.Fragment>
      ))}
    </div>
  );
};

export default CurrentPlanCard;
